export default __webpack_public_path__ + "static/media/ContactSmile.2bc38ec7.svg";